import { AxiosResponse } from 'axios';

export type TProductType = 'NN' | 'EASE' | 'NN_AND_EASE';

export type TISODate = string;

export type TSubscriptionID = number | string;

export type TSubscriptionStatus = 'future' | 'cancelled' | 'active' | 'non_renewing' | 'in_trial' | 'paused';

export interface IBaseSubscription {
  autoRenewing: boolean;
  createdAt: TISODate;
  expiresAt: TISODate;
  id: TSubscriptionID;
  nextCharge: TISODate;
  numberIntervals: number;
  productId: number;
  trialEndsAt: TISODate | null;
}

export interface ILegacySubscription extends IBaseSubscription {
  autoRenewing: boolean;
  createdAt: TISODate;
  expiresAt: TISODate;
  id: number;
  isLegacy: boolean;
  isTerminable: boolean;
  nextCharge: TISODate;
  numberIntervals: number;
  productId: number;
  project: TProductType;
  trialEndsAt: TISODate | null;
  type: string;
  secondProductId: undefined;
}

export interface IChargebeeSubscription extends IBaseSubscription {
  active: number | boolean;
  autoRenewing: boolean;
  cancelledAt?: string;
  createdAt: TISODate;
  expiresAt: TISODate;
  id: string;
  isChargeBee: true;
  isTerminable: boolean;
  itemId: string;
  nextCharge: TISODate;
  numberIntervals: number;
  productId: number;
  secondProductId?: string;
  status: TSubscriptionStatus;
  trialEndsAt: TISODate | null;
  trialPeriodDays: number;
  updatedAt: TISODate;
  userId: number;
}

export type ISubscription = IChargebeeSubscription | ILegacySubscription;

export function isChargebee(subscription: ISubscription): subscription is IChargebeeSubscription {
  return Boolean((subscription as IChargebeeSubscription).isChargeBee);
}

export enum ESubscriptionRestoreState {
  None,
  Running,
  Success,
}

export type TGetSubscriptionResponse = AxiosResponse<{ subscriptions: ISubscription[] }>;

export interface ISubscriptionStatusProps {
  subscription: IChargebeeSubscription;
}

export interface ITerminateSubscriptionPayload {
  subscriptionId: TSubscriptionID;
  terminate: boolean;
}
